export enum ToolbarButton {
  HOME = 'HOME',
  CATALOGUE = 'CATALOGUE',
  MY_SERVICES = 'MY_SERVICES',
  INSPIRATION_LOUNGE = 'INSPIRATION_LOUNGE',
  RESOURCES = 'RESOURCES',
  MY_SANDBOX = 'MY_SANDBOX',
  SERVICES = 'SERVICES',
  AUDIT_TRAIL = 'AUDIT_TRAIL',
  DOWNLOAD_IAC = 'DOWNLOAD_IAC'
}
